import BulkTransform from '../../models/BulkTransform';
import Delta from '../../models/LedgerDelta';

export default Delta(BulkTransform.argType);
